import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import CatSubMenu from "./CatSubMenu";

const CatMenuItems = (props) => {
  const [isShown, setIsShown] = useState(false);

  const onHoverHandler = () => {
    setIsShown(true);
  };

  const onDropHandler = () => {
    setIsShown(false);
  };
  return props.items.submenu && props.items.submenu.length > 0 ? (
    <li onMouseEnter={onHoverHandler} onMouseLeave={onDropHandler}>
      {props.depth > 1 ? (
        <Link to="#">{props.items.title + ">"}</Link>
      ) : (
        <Link to="#">{props.items.title + ">"}</Link>
      )}

      <CatSubMenu
        isShown={isShown}
        submenu={props.items.submenu}
        depth={props.depth}
      />
    </li>
  ) : (
    <li>
      <Link to={`/category/${props.items.categoryId}`}>{props.items.title}</Link>
    </li>
  );
};

export default CatMenuItems;
